import React, { useCallback, useState } from "react";
import MdaeSelectBox from "../../../common_components/common_widgets/select-box";
import MdaeTagBox from "../../../common_components/common_widgets/tag-box";
import MdaePopup, {
  MdaePopupTitle,
  MdaePopupContent,
  MdaePopupFooter,
  MdaePopupFooterEndButtons,
  MdaePopupFooterStartButtons,
} from "../../../common_components/common_widgets/popup";
import { useDispatch, useSelector } from "react-redux";
import { actions as asyncActions } from "async-ops";
import { isEqual } from "date-fns";
import { bindActionCreators } from "redux";
import MdaeButton from "../../../common_components/common_widgets/button";
import { cloneDeep } from "lodash";
import {
  ADD_PROCESS_TEPLATE_ROUND_TASK,
  formatProcessRoundTaskObjectToSave,
  RESET_ADD_TASK_TRIGGER_POPUP_VALIDATION,
  SET_IS_TASK_TEMPLATE_ADDED,
  SET_PREVIOUS_REF_TASK_DATA,
  SET_TASK_FORM_DATA,
  SET_TASK_TEMPLATE_DATASOURCE,
  SET_TRIGGER_LIST,
  TOGGLE_ADD_TASK_POPUP,
  TOGGLE_ROUND_TASK_TYPE,
  UPDATE_PROCESS_TEPLATE_ROUND_TASK,
  FILTER_ASSIGNED_TO_USER_TYPES_BY_WORKFLOW,
  MDAUDIT_TRANSFER,
} from "./reducer/process-template-reducer";
import { useEffect } from "react";
import { useMemo } from "react";
import {
  ADD_EA_ROUND_TASK,
  formatEaRoundTaskObjectToSave,
} from "../../external-audit/reducers/round-task-reducer";
import Guid from "devextreme/core/guid";
import $ from "jquery";
import dxAccordion from "devextreme/ui/accordion";
import {
  defaultTakTemplateFormData,
  ENABLE_DISABLE_TASK_TEMPLATE_FIELDS,
  RESET_TASK_TEMPLATE_POPUP_VALIDATION,
  SET_TASK_TEMPLATE_FORM_DATA,
} from "../../task-template/reducers/task-template-reducer";
import { Validator } from "devextreme-react";
import { CustomRule, RequiredRule } from "devextreme-react/validator";
import MdaeNumericBox from "../../../common_components/common_widgets/numeric-box";
import { toggleSelectExternalUserPopup } from "../../../common_components/user-task-list/add-user-task";
import SelectExternalUser from "../../../common_components/select-external-user";
import { openTaskTemplateInEditMode } from "../../task-template/add-task-template";
import { transferredTaskTriggerErrorMsg } from "./task-card";
import dxSelectBox from "devextreme/ui/select_box";
import dxTagBox from "devextreme/ui/tag_box";
import { SET_ASSIGNED_USER_TYPE } from "../../../common_components/user-task-list/reducers/user-task-list-reducer";
import { USER_TYPE } from "../../../common_components/user-task-list/constant";
import SelectAssignedGroupUser, {
  toggleSelectAssignedGroupUserPopup,
} from "../../../common_components/select-assigned-user/component";
import { GET_EXTERNAL_USER_GROUP_LIST_WITH_ASSOCIATION } from "../../../common_components/user-task-list/services/get-external-user-group-list-with-association";
import { GET_TASK_GROUP_LIST_WITH_ASSOCIATION } from "../../../common_components/user-task-list/services/get-task-group-list-with-association";
export const ADD_TASK_MODE = {
  ADD: "ADD",
  EDIT: "EDIT",
};
export const openTaskTriggerPopupInEditMode = (
  toggleAddNewTaskPopupVisible
) => {
  toggleAddNewTaskPopupVisible(true, "Edit Task");
};

const validationCallbackForInvalidData = (
  widgetName: "SelectBox" | "TagBox",
  id: string,
  valueExpr: string,
  value
) => {
  let dataSource = null;
  let dataSourceitems = null;
  let widetInstace = null;
  switch (widgetName) {
    case "TagBox":
      widetInstace = dxTagBox.getInstance(document.getElementById(id));
      dataSource = widetInstace.getDataSource();
      dataSource.load();
      dataSourceitems = dataSource.items() as any[];
      if (dataSourceitems?.length > 0 && value?.length > 0) {
        return dataSourceitems?.some((x) => value.includes(x[valueExpr]));
      }
      break;
    case "SelectBox":
      widetInstace = dxSelectBox.getInstance(document.getElementById(id));
      dataSource = widetInstace.getDataSource();
      dataSource.load();
      dataSourceitems = dataSource.items() as any[];
      if (dataSourceitems?.length > 0) {
        return Boolean(dataSourceitems?.find((x) => x[valueExpr] === value));
      }
  }

  return false;
};

const AddTask: React.FC<any> = (props) => {
  const dispatch = useDispatch();
  const [isAddButtonClicked, setIsAddButtonClicked] = useState(false);
  const taskTriggerValidationGroup = "taskTriggerValidationGroup";
  const levelList = useSelector(
    (state) => state["processTemplateReducer"].levelList,
    isEqual
  );
  const addTaskModeValue = useSelector(
    (state) => state["processTemplateReducer"].addTaskModeValue,
    isEqual
  );
  const originalTriggerList = useSelector(
    (state) => state["processTemplateReducer"].originalTriggerList,
    isEqual
  );
  const triggerList = useSelector(
    (state) => state["processTemplateReducer"].triggerList,
    isEqual
  );
  const refTaskList = useSelector(
    (state) => state["processTemplateReducer"].refTaskList,
    isEqual
  );
  const auditStatusList = useSelector(
    (state) => state["processTemplateReducer"].auditStatusList,
    isEqual
  );
  const caseStatusList = useSelector(
    (state) => state["processTemplateReducer"].caseStatusList,
    isEqual
  );
  const taskStatusList = useSelector(
    (state) => state["processTemplateReducer"].taskStatusList,
    isEqual
  );
  const taskFormData = useSelector(
    (state) => state["processTemplateReducer"].taskFormData,
    isEqual
  );
  const selectedRoundData = useSelector(
    (state) => state["processTemplateReducer"].selectedRoundData,
    isEqual
  );
  const taskCategoryTypeList = useSelector(
    (state) => state["processTemplateReducer"].taskCategoryTypeList,
    isEqual
  );
  const caseRoundOutcomesList = useSelector(
    (state) => state["processTemplateReducer"].caseRoundOutcomesList,
    isEqual
  );
  const processTemplateRoundList = useSelector(
    (state) => state["processTemplateReducer"].processTemplateRoundList,
    isEqual
  );

  const previousRefTaskList = useSelector(
    (state) => state["processTemplateReducer"].previousRefTaskList,
    isEqual
  );
  const originalRefTaskList = useSelector(
    (state) => state["processTemplateReducer"].originalRefTaskList,
    isEqual
  );
  const roundTaskTypeMode = useSelector(
    (state) => state["processTemplateReducer"].roundTaskTypeMode,
    isEqual
  );
  const isNewTaskTemplateAdded = useSelector(
    (state) => state["processTemplateReducer"].isNewTaskTemplateAdded,
    isEqual
  );
  const processRoundData = useSelector(
    (state) => state["processTemplateReducer"].processRoundData,
    isEqual
  );
  const eaRound = useSelector(
    (state) => state["roundTaskReducer"].eaRound,
    isEqual
  );
  const accordionNo = useSelector(
    (state) => state["processTemplateReducer"].accordionNo,
    isEqual
  );
  const externalUserList = useSelector(
    (state: any) =>
      state.externalUsersReducer.externalUserListForExternalUserGroup,
    isEqual
  );
  const assignedToEnums = useSelector(
    (state: any) => state.taskTemplateReducer.assignedToEnums,
    isEqual
  );
  const assignedToUserTypeDataSource = useSelector(
    (state: any) =>
      state.taskTemplateReducer.assignedToUserTypeDataSource.filter(
        (x) =>
          x.value === assignedToEnums.processManager ||
          x.value === assignedToEnums.designatedMdauditUser ||
          x.value === assignedToEnums.externalUser ||
          x.value === assignedToEnums.externalUserGroup ||
          x.value === assignedToEnums.taskGroup
      ),
    isEqual
  );

  const activeUserList = useSelector(
    (state: any) => state.taskTemplateReducer.activeUserList,
    isEqual
  );
  const workflowModuleTypeEnums = useSelector(
    (state: any) => state.taskTemplateReducer.workflowModuleTypeEnums,
    isEqual
  );
  const taskLevelListByWorkflow = useSelector(
    (state: any) => state.taskTemplateReducer.taskLevelListByWorkflow,
    isEqual
  );
  const isSelectExternalUserPopupVisible = useSelector(
    (state: any) => state.userTaskListReducer.isSelectExternalUserPopupVisible,
    isEqual
  );
  const isAddNewTaskPopupVisible = useSelector(
    (state) => state["processTemplateReducer"].isAddNewTaskPopupVisible,
    isEqual
  );
  const isAddTaskTemplatePopupVisible = useSelector(
    (state) => state["taskTemplateReducer"].isAddTaskTemplatePopupVisible
  );
  const isSelectAssignedGroupUserPopupVisible = useSelector(
    (state: any) =>
      state.userTaskListReducer.isSelectAssignedGroupUserPopupVisible
  );
  const taskGroupList = useSelector(
    (state: any) => state.taskGroupReducer.taskGroupList
  );
  const externalUserGroupList = useSelector(
    (state: any) => state.externalUsersReducer.externalUserGroupList
  );
  if (isNewTaskTemplateAdded) {
    dispatch({
      type: SET_TASK_TEMPLATE_DATASOURCE,
      data: { taskFormData: taskFormData },
    });
    dispatch({
      type: SET_TASK_FORM_DATA,
      data: {
        taskFormData: { ...taskFormData, refTaskId: taskFormData.refTaskId },
        isTemplateChange: true,
      },
    });
    dispatch({
      type: SET_IS_TASK_TEMPLATE_ADDED,
      data: false,
    });
  }
  useEffect(() => {
    dispatch({
      type: SET_TASK_FORM_DATA,
      data: { taskFormData: taskFormData },
    });
  }, [props.isAddNewTaskPopupVisible]);

  const asyncAction = bindActionCreators(
    {
      asyncOperationStart: asyncActions.asyncOperationStart,
    },
    dispatch
  );

  const valueChangeEvent = useCallback(
    (e) => {
      if (e.event)
        dispatch({
          type: SET_TASK_FORM_DATA,
          data: {
            taskFormData: {
              ...taskFormData,
              [e.component.option("name")]: e.value,
            },
          },
        });
    },
    [taskFormData]
  );

  const getNewTaskPopupTitle = () => {
    return (
      <MdaePopupTitle
        closePopupHandler={() => {
          props.toggleAddNewTaskPopupVisible(false);
        }}
      >
        customTitleRender=
        {1 == 1
          ? props.addTaskPopupTitle
          : () => {
              return <div>Add Task</div>;
            }}
      </MdaePopupTitle>
    );
  };

  const renderPopupContent = useMemo(() => {
    return (
      <div
        className={
          "process-template-parent-container" +
          (props.isViewOnlyMode ? " mdae-readonly-content" : "")
        }
      >
        {isSelectExternalUserPopupVisible &&
          isAddNewTaskPopupVisible &&
          !isAddTaskTemplatePopupVisible && (
            <SelectExternalUser
              isPopupOpenedFromProcessTemplateTaskTrigger={true}
            ></SelectExternalUser>
          )}
        {isSelectAssignedGroupUserPopupVisible &&
          isAddNewTaskPopupVisible &&
          !isAddTaskTemplatePopupVisible && (
            <SelectAssignedGroupUser
              isPopupOpenedFromProcessTemplateTaskTrigger={true}
            ></SelectAssignedGroupUser>
          )}
        <MdaeSelectBox
          id={"ddlLevel"}
          mdaeDropDownBoxTitle={"Level"}
          displayExpr={"displayName"}
          valueExpr={"value"}
          width={190}
          onValueChanged={(e) => {
            dispatch({
              type: SET_TASK_TEMPLATE_DATASOURCE,
              data: { taskFormData: { ...taskFormData, level: e.value } },
            });
          }}
          mdaeDataUpdaterConfig={[
            {
              actionType: SET_TASK_FORM_DATA,
              reducerName: "processTemplateReducer",
              widgetOptionBindings: {
                value: "taskFormData.level",
                dataSource: "levelList",
              },
            },
          ]}
        ></MdaeSelectBox>
        <div className="widget-separation-margin-top template-container">
          <MdaeSelectBox
            id={"ddlTaskTemplate"}
            mdaeDropDownBoxTitle={"Task Template"}
            displayExpr={"name"}
            required
            valueExpr={"refTaskId"}
            width={410}
            onValueChanged={(e) => {
              if (e.event) {
                const selectedItem = e.component.option("selectedItem");
                dispatch({
                  type: SET_TASK_FORM_DATA,
                  data: {
                    taskFormData: {
                      ...taskFormData,
                      dueAfter: selectedItem?.dueAfter,
                      dueInterval: selectedItem?.dueInterval,
                      assignedToUserType: selectedItem?.assignedToUserTypeValue,
                      assignedToUserId: selectedItem?.assignedToUserId,
                      refTaskId: e.value,
                    },
                    isTemplateChange: true,
                  },
                });
                dispatch({
                  type: SET_TRIGGER_LIST,
                  data: {
                    originalTriggerList: originalTriggerList,
                    sequenceNo: selectedRoundData.sequenceNo,
                    levelValue: taskFormData.level,
                    previousRefTaskList: previousRefTaskList,
                  },
                });
              }
            }}
            mdaeDataUpdaterConfig={[
              {
                actionType: SET_TASK_FORM_DATA,
                reducerName: "processTemplateReducer",
                widgetOptionBindings: {
                  value: "taskFormData.refTaskId",
                },
              },
              {
                actionType: SET_TASK_TEMPLATE_DATASOURCE,
                reducerName: "processTemplateReducer",
                widgetOptionBindings: {
                  dataSource: "refTaskList",
                },
              },
              {
                actionType: RESET_ADD_TASK_TRIGGER_POPUP_VALIDATION,
                reducerName: "processTemplateReducer",
                widgetOptionBindings: {
                  isValid: "isTasktriggerFormDataValid",
                },
              },
            ]}
          >
            <Validator validationGroup={taskTriggerValidationGroup}>
              <RequiredRule message="Template is required" />
            </Validator>
          </MdaeSelectBox>
          {taskFormData.taskTemplateUpdatedBy === MDAUDIT_TRANSFER && (
            <MdaeButton
              id={""}
              role={"dxButton"}
              stylingMode={"text"}
              onClick={() => {
                openTaskTemplateInEditMode(
                  { refTaskId: taskFormData.refTaskId },
                  props.toggleTaskTemplatePopup,
                  dispatch
                );
                dispatch({
                  type: ENABLE_DISABLE_TASK_TEMPLATE_FIELDS,
                  data: {
                    isLevelValueDisabled: true,
                    isModuleTypeDisabled: true,
                  },
                });
              }}
              className={"add-new-template-button"}
              elementAttr={{ title: transferredTaskTriggerErrorMsg }}
            >
              <div className={"dx-icon warning-red"}></div>
            </MdaeButton>
          )}

          {taskFormData.taskTemplateUpdatedBy !== MDAUDIT_TRANSFER && (
            <MdaeButton
              id={""}
              role={"dxButton"}
              stylingMode={"text"}
              onClick={() => {
                props.toggleTaskTemplatePopup(true);
                dispatch({
                  type: SET_TASK_TEMPLATE_FORM_DATA,
                  data: {
                    taskTemplateFormData: cloneDeep(defaultTakTemplateFormData),
                    initialTaskTemplateFormData: cloneDeep(
                      defaultTakTemplateFormData
                    ),
                  },
                });

                dispatch({
                  type: RESET_TASK_TEMPLATE_POPUP_VALIDATION,
                  data: {
                    isTaskTemplateFormDataValid: true,
                  },
                });
                const defaultTaskFormData = {
                  moduleTypeValue: "EAW",
                  levelValue: null,
                };
                let isLevelValueDisabled = false;
                if (
                  taskFormData.level &&
                  taskFormData.level.toUpperCase() === "EAC"
                ) {
                  defaultTaskFormData.levelValue = "EAC";
                  isLevelValueDisabled = true;
                }
                if (
                  taskFormData.level &&
                  taskFormData.level.toUpperCase() === "EA"
                ) {
                  defaultTaskFormData.levelValue = "EA";
                  isLevelValueDisabled = true;
                }

                dispatch({
                  type: SET_TASK_TEMPLATE_FORM_DATA,
                  data: {
                    taskTemplateFormData: defaultTaskFormData,
                  },
                });
                dispatch({
                  type: ENABLE_DISABLE_TASK_TEMPLATE_FIELDS,
                  data: {
                    isLevelValueDisabled: isLevelValueDisabled,
                    isModuleTypeDisabled: true,
                  },
                });
              }}
              className={"add-new-template-button"}
              elementAttr={{ title: "Create New Task Template" }}
            >
              <div
                className={
                  "fa fa-plus application-section-primary-color add-new-template-link"
                }
              ></div>
            </MdaeButton>
          )}
        </div>
        <div className="widget-separation-margin-top template-container">
          <div style={{ marginRight: "10px" }}>
            <MdaeNumericBox
              id={""}
              mdaeNumberBoxTitle={"Due After"}
              min={0}
              width={200}
              required={true}
              mdaeDataUpdaterConfig={[
                {
                  actionType: SET_TASK_FORM_DATA,
                  reducerName: "processTemplateReducer",
                  widgetOptionBindings: {
                    value: "taskFormData.dueAfter",
                  },
                },
                {
                  actionType: RESET_ADD_TASK_TRIGGER_POPUP_VALIDATION,
                  reducerName: "processTemplateReducer",
                  widgetOptionBindings: {
                    isValid: "isTasktriggerFormDataValid",
                  },
                },
              ]}
            >
              <Validator validationGroup={taskTriggerValidationGroup}>
                <CustomRule
                  validationCallback={(e) => {
                    if (isAddButtonClicked) {
                      if (e.value) return true;
                      else return false;
                    } else {
                      if (e.value || taskFormData.refTaskId <= 0) return true;
                      else return false;
                    }
                  }}
                  message="Please enter due after."
                />
              </Validator>
            </MdaeNumericBox>
          </div>

          <div>
            <MdaeSelectBox
              id={""}
              required={true}
              mdaeDropDownBoxTitle={"Due Interval"}
              dataSource={["Days", "Weeks", "Months", "Quarters"]}
              mdaeDataUpdaterConfig={[
                {
                  actionType: SET_TASK_FORM_DATA,
                  reducerName: "processTemplateReducer",
                  widgetOptionBindings: {
                    value: "taskFormData.dueInterval",
                  },
                },
                {
                  actionType: RESET_ADD_TASK_TRIGGER_POPUP_VALIDATION,
                  reducerName: "processTemplateReducer",
                  widgetOptionBindings: {
                    isValid: "isTasktriggerFormDataValid",
                  },
                },
              ]}
            >
              <Validator validationGroup={taskTriggerValidationGroup}>
                <RequiredRule message="Please select due interval." />
              </Validator>
            </MdaeSelectBox>
          </div>
        </div>
        <div className={"widget-separation-margin-top"}>
          <MdaeSelectBox
            id={"ddlTrigger"}
            mdaeDropDownBoxTitle={"Trigger"}
            displayExpr={"displayName"}
            required
            valueExpr={"value"}
            width={410}
            onValueChanged={(e) => {
              if (e.event) {
                dispatch({
                  type: SET_TASK_FORM_DATA,
                  data: {
                    taskFormData: {
                      ...taskFormData,
                      triggerId: e.value,
                      previousRefTaskId: null,
                      previousTaskStatusId: null,
                      caseStatusId: null,
                      caseOutcomeIds: [],
                      auditStatusId: null,
                    },
                  },
                });
              }
            }}
            mdaeDataUpdaterConfig={[
              {
                actionType: SET_TASK_FORM_DATA,
                reducerName: "processTemplateReducer",
                widgetOptionBindings: {
                  value: "taskFormData.triggerId",
                },
              },
              {
                actionType: SET_TRIGGER_LIST,
                reducerName: "processTemplateReducer",
                widgetOptionBindings: {
                  dataSource: "triggerList",
                },
              },
              {
                actionType: RESET_ADD_TASK_TRIGGER_POPUP_VALIDATION,
                reducerName: "processTemplateReducer",
                widgetOptionBindings: {
                  isValid: "isTasktriggerFormDataValid",
                },
              },
            ]}
          >
            <Validator validationGroup={taskTriggerValidationGroup}>
              <RequiredRule message="Trigger type is required" />
            </Validator>
          </MdaeSelectBox>
        </div>
        <div className={"widget-separation-margin-top"}>
          <MdaeSelectBox
            id={"ddlPreviousTask"}
            mdaeDropDownBoxTitle={"Previous Task"}
            displayExpr={"refTaskName"}
            valueExpr={"uniqueProcessTemplateTaskTriggerId"}
            width={410}
            visible={taskFormData.triggerId == "PTSC"}
            disabled={taskFormData.triggerId != "PTSC"}
            value={taskFormData.previousRefTaskId}
            name={"previousRefTaskId"}
            onValueChanged={valueChangeEvent}
            mdaeDataUpdaterConfig={[
              {
                actionType: SET_PREVIOUS_REF_TASK_DATA,
                reducerName: "processTemplateReducer",
                widgetOptionBindings: {
                  dataSource: "previousRefTaskList",
                },
              },
              {
                actionType: RESET_ADD_TASK_TRIGGER_POPUP_VALIDATION,
                reducerName: "processTemplateReducer",
                widgetOptionBindings: {
                  isValid: "isTasktriggerFormDataValid",
                },
              },
            ]}
          >
            <Validator validationGroup={taskTriggerValidationGroup}>
              <RequiredRule message="Previous Task is required" />
            </Validator>
          </MdaeSelectBox>
        </div>
        <div className={"widget-separation-margin-top"}>
          <MdaeSelectBox
            id={"ddlPreviousTaskStatus"}
            mdaeDropDownBoxTitle={"Previous Task Status"}
            displayExpr={"displayAlias"}
            valueExpr={"statusId"}
            width={410}
            visible={taskFormData.triggerId == "PTSC"}
            disabled={taskFormData.triggerId != "PTSC"}
            value={taskFormData.previousTaskStatusId}
            name={"previousTaskStatusId"}
            onValueChanged={valueChangeEvent}
            mdaeDataUpdaterConfig={[
              {
                actionType: SET_TASK_FORM_DATA,
                reducerName: "processTemplateReducer",
                widgetOptionBindings: {
                  dataSource: "taskStatusForTrigger",
                },
                dataSourceOptions: {
                  dataSourceOptions: { paginate: false },
                },
              },
              {
                actionType: RESET_ADD_TASK_TRIGGER_POPUP_VALIDATION,
                reducerName: "processTemplateReducer",
                widgetOptionBindings: {
                  isValid: "isTasktriggerFormDataValid",
                },
              },
            ]}
          >
            <Validator validationGroup={taskTriggerValidationGroup}>
              <RequiredRule message="Status is required" />
              <CustomRule
                reevaluate={true}
                validationCallback={(e) =>
                  validationCallbackForInvalidData(
                    "SelectBox",
                    "ddlPreviousTaskStatus",
                    "statusId",
                    e.value
                  )
                }
                message="Please select a valid Previous Task Status"
              />
            </Validator>
          </MdaeSelectBox>
        </div>
        <div className={"widget-separation-margin-top"}>
          <MdaeSelectBox
            id={"ddlCaseStatus"}
            mdaeDropDownBoxTitle={"Case Status Change"}
            displayExpr={"displayAlias"}
            valueExpr={"statusId"}
            width={410}
            visible={taskFormData.triggerId == "CSC"}
            disabled={taskFormData.triggerId != "CSC"}
            value={taskFormData.caseStatusId}
            name={"caseStatusId"}
            onValueChanged={valueChangeEvent}
            mdaeDataUpdaterConfig={[
              {
                actionType: SET_TASK_FORM_DATA,
                reducerName: "processTemplateReducer",
                widgetOptionBindings: {
                  dataSource: "caseStatusForTrigger",
                },
                dataSourceOptions: {
                  dataSourceOptions: { paginate: false },
                },
              },
              {
                actionType: RESET_ADD_TASK_TRIGGER_POPUP_VALIDATION,
                reducerName: "processTemplateReducer",
                widgetOptionBindings: {
                  isValid: "isTasktriggerFormDataValid",
                },
              },
            ]}
          >
            <Validator validationGroup={taskTriggerValidationGroup}>
              <RequiredRule message="Status is required" />
              <CustomRule
                reevaluate={true}
                validationCallback={(e) =>
                  validationCallbackForInvalidData(
                    "SelectBox",
                    "ddlCaseStatus",
                    "statusId",
                    e.value
                  )
                }
                message="Please select a valid Status"
              />
            </Validator>
          </MdaeSelectBox>
        </div>
        <div className={"widget-separation-margin-top"}>
          <MdaeTagBox
            id={"ddlCaseOutcomes"}
            mdaeTagBoxTitle={"Case Round Outcomes"}
            displayExpr={"eaOutcomeName"}
            valueExpr={"eaOutcomeId"}
            width={410}
            showSelectionControls={true}
            maxDisplayedTags={1}
            visible={taskFormData.triggerId == "CRO" || taskFormData.triggerId == "PRCRO"}
            disabled={taskFormData.triggerId != "CRO" && taskFormData.triggerId != "PRCRO"}
            dataSource={caseRoundOutcomesList}
            value={taskFormData.caseOutcomeIds}
            name={"caseOutcomeIds"}
            onValueChanged={valueChangeEvent}
            mdaeDataUpdaterConfig={[
              {
                actionType: RESET_ADD_TASK_TRIGGER_POPUP_VALIDATION,
                reducerName: "processTemplateReducer",
                widgetOptionBindings: {
                  isValid: "isTasktriggerFormDataValid",
                },
              },
            ]}
          >
            <Validator validationGroup={taskTriggerValidationGroup}>
              <RequiredRule message="Case Round Outcome is required" />
              <CustomRule
                reevaluate={true}
                validationCallback={(e) =>
                  validationCallbackForInvalidData(
                    "TagBox",
                    "ddlCaseOutcomes",
                    "eaOutcomeId",
                    e.value
                  )
                }
                message="Please select valid Case Round Outcomes"
              />
            </Validator>
          </MdaeTagBox>
        </div>
        <div className={"widget-separation-margin-top"}>
          <MdaeSelectBox
            id={"ddlAuditStatusChange"}
            mdaeDropDownBoxTitle={"Audit Status Change"}
            displayExpr={"displayAlias"}
            valueExpr={"statusId"}
            width={410}
            visible={taskFormData.triggerId == "ASC"}
            disabled={taskFormData.triggerId != "ASC"}
            value={taskFormData.auditStatusId}
            name={"auditStatusId"}
            onValueChanged={valueChangeEvent}
            mdaeDataUpdaterConfig={[
              {
                actionType: SET_TASK_FORM_DATA,
                reducerName: "processTemplateReducer",
                widgetOptionBindings: {
                  dataSource: "auditStatusForTrigger",
                },
                dataSourceOptions: {
                  dataSourceOptions: { paginate: false },
                },
              },
              {
                actionType: RESET_ADD_TASK_TRIGGER_POPUP_VALIDATION,
                reducerName: "processTemplateReducer",
                widgetOptionBindings: {
                  isValid: "isTasktriggerFormDataValid",
                },
              },
            ]}
          >
            <Validator validationGroup={taskTriggerValidationGroup}>
              <RequiredRule message="Status is required" />
              <CustomRule
                reevaluate={true}
                validationCallback={(e) =>
                  validationCallbackForInvalidData(
                    "SelectBox",
                    "ddlAuditStatusChange",
                    "statusId",
                    e.value
                  )
                }
                message="Please select a valid Status"
              />
            </Validator>
          </MdaeSelectBox>
        </div>
        <div className={"widget-separation-margin-top"}>
          <MdaeSelectBox
            id={"ddlProcessTempateTriggerAssignedTo"}
            mdaeDropDownBoxTitle={"Assigned To"}
            displayExpr={"displayName"}
            valueExpr={"value"}
            name="assignedTo"
            dataSource={assignedToUserTypeDataSource}
            mdaeDataUpdaterConfig={[
              {
                actionType: SET_TASK_FORM_DATA,
                reducerName: "processTemplateReducer",
                widgetOptionBindings: {
                  value: "taskFormData.assignedToUserType",
                },
              },
              {
                actionType: RESET_ADD_TASK_TRIGGER_POPUP_VALIDATION,
                reducerName: "processTemplateReducer",
                widgetOptionBindings: {
                  isValid: "isTasktriggerFormDataValid",
                },
              },
            ]}
            onValueChanged={(e) => {
              if (e.event) {
                if (e.value == assignedToEnums.externalUser) {
                  toggleSelectExternalUserPopup(dispatch, true);
                } else if (e.value == assignedToEnums.externalUserGroup) {
                  asyncAction.asyncOperationStart(
                    GET_EXTERNAL_USER_GROUP_LIST_WITH_ASSOCIATION,
                    {}
                  );
                  toggleSelectAssignedGroupUserPopup(dispatch, true);
                  dispatch({
                    type: SET_ASSIGNED_USER_TYPE,
                    data: {
                      assignedUserType: USER_TYPE.EG,
                    },
                  });
                } else if (e.value == assignedToEnums.taskGroup) {
                  asyncAction.asyncOperationStart(
                    GET_TASK_GROUP_LIST_WITH_ASSOCIATION,
                    {}
                  );
                  toggleSelectAssignedGroupUserPopup(dispatch, true);
                  dispatch({
                    type: SET_ASSIGNED_USER_TYPE,
                    data: {
                      assignedUserType: USER_TYPE.TG,
                    },
                  });
                } else {
                  let originalAssignedToUserTypeList = assignedToUserTypeDataSource.filter(
                    (x) => !x.externalUserId
                  );

                  dispatch({
                    type: FILTER_ASSIGNED_TO_USER_TYPES_BY_WORKFLOW,
                    assignedToUserTypeList: originalAssignedToUserTypeList,
                  });
                }
              }
            }}
          ></MdaeSelectBox>
        </div>
        {taskFormData.assignedToUserType ===
          assignedToEnums.designatedMdauditUser && (
          <div className={"widget-separation-margin-top"}>
            <MdaeSelectBox
              id={"ddlProcessTempateTriggerUserTypes"}
              mdaeDropDownBoxTitle={"MDaudit User"}
              displayExpr={"assignedToUserTypeValue"}
              valueExpr={"assignedToUserId"}
              name="MDauditUser"
              disabled={
                taskFormData.assignedToUserType === assignedToEnums.externalUser
              }
              required={true}
              dataSource={
                taskFormData.assignedToUserType ===
                assignedToEnums.designatedMdauditUser
                  ? activeUserList
                  : externalUserList
              }
              value={taskFormData.assignedToUserId}
              onValueChanged={(e) => {
                if (e.event) {
                  dispatch({
                    type: SET_TASK_FORM_DATA,
                    data: {
                      taskFormData: {
                        ...taskFormData,
                        assignedToUserId: e.value,
                      },
                    },
                  });
                }
              }}
              mdaeDataUpdaterConfig={[
                {
                  actionType: RESET_ADD_TASK_TRIGGER_POPUP_VALIDATION,
                  reducerName: "processTemplateReducer",
                  widgetOptionBindings: {
                    isValid: "isTaskTemplateFormDataValid",
                  },
                },
              ]}
            >
              <Validator validationGroup={taskTriggerValidationGroup}>
                <CustomRule
                  validationCallback={(e) => {
                    if (
                      taskFormData.assignedToUserType ===
                      assignedToEnums.designatedMdauditUser
                    ) {
                      if (e.value) return true;
                      else return false;
                    } else {
                      return true;
                    }
                  }}
                  message="Please select MDAudit User."
                />
              </Validator>
            </MdaeSelectBox>
          </div>
        )}
        {(taskFormData.assignedToUserType === assignedToEnums.externalUser ||
          taskFormData.assignedToUserType ===
            assignedToEnums.externalUserGroup ||
          taskFormData.assignedToUserType === assignedToEnums.taskGroup) && (
          <div className={"widget-separation-margin-top"}>
            <MdaeSelectBox
              id={"ddlProcessTempateTriggerUserTypes"}
              mdaeDropDownBoxTitle={
                taskFormData.assignedToUserType === assignedToEnums.taskGroup
                  ? "Task Group"
                  : taskFormData.assignedToUserType ===
                    assignedToEnums.externalUserGroup
                  ? "External User Group"
                  : "External User"
              }
              displayExpr={
                taskFormData.assignedToUserType === assignedToEnums.taskGroup
                  ? "taskGroupName"
                  : taskFormData.assignedToUserType ===
                    assignedToEnums.externalUserGroup
                  ? "externalUserGroupName"
                  : "externalUserName"
              }
              valueExpr={
                taskFormData.assignedToUserType === assignedToEnums.taskGroup
                  ? "taskGroupId"
                  : taskFormData.assignedToUserType ===
                    assignedToEnums.externalUserGroup
                  ? "externalUserGroupId"
                  : "externalUserId"
              }
              name="MDauditUser"
              disabled={
                taskFormData.assignedToUserType ===
                  assignedToEnums.externalUser ||
                taskFormData.assignedToUserType ===
                  assignedToEnums.externalUserGroup ||
                taskFormData.assignedToUserType === assignedToEnums.taskGroup
              }
              required={true}
              dataSource={
                taskFormData.assignedToUserType === assignedToEnums.taskGroup
                  ? taskGroupList
                  : taskFormData.assignedToUserType ===
                    assignedToEnums.externalUserGroup
                  ? externalUserGroupList
                  : externalUserList
              }
              value={taskFormData.assignedToUserId}
              onValueChanged={(e) => {
                if (e.event) {
                  dispatch({
                    type: SET_TASK_FORM_DATA,
                    data: {
                      taskFormData: {
                        ...taskFormData,
                        assignedToUserId: e.value,
                      },
                    },
                  });
                }
              }}
              mdaeDataUpdaterConfig={[
                {
                  actionType: RESET_ADD_TASK_TRIGGER_POPUP_VALIDATION,
                  reducerName: "processTemplateReducer",
                  widgetOptionBindings: {
                    isValid: "isTaskTemplateFormDataValid",
                  },
                },
              ]}
            >
              <Validator validationGroup={taskTriggerValidationGroup}>
                <CustomRule
                  validationCallback={(e) => {
                    if (
                      taskFormData.assignedToUserType ===
                      assignedToEnums.designatedMdauditUser
                    ) {
                      if (e.value) return true;
                      else return false;
                    } else {
                      return true;
                    }
                  }}
                  message="Please select MDAudit User."
                />
              </Validator>
            </MdaeSelectBox>
          </div>
        )}
      </div>
    );
  }, [
    taskFormData,
    props.isAddNewTaskPopupVisible,
    triggerList,
    props.isViewOnlyMode,
  ]);
  const getPopupContent = () => {
    return renderPopupContent;
  };
  const addTaskData = (params) => {
    let result = null;
    if (params.validationGroup) result = params.validationGroup.validate();
    if (result && result.isValid) {
      var templateSelected = originalRefTaskList?.filter(
        (x) => x.refTaskId == taskFormData.refTaskId
      );
      switch (taskFormData.triggerId) {
        case "CSC":
          taskFormData.status = JSON.stringify({
            caseStatusId: taskFormData.caseStatusId,
          });
          break;
        case "PTSC":
          taskFormData.status = JSON.stringify({
            uniqueProcessTemplateTaskTriggerId: taskFormData.previousRefTaskId,
            statusId: taskFormData.previousTaskStatusId,
          });
          break;
        case "ASC":
          taskFormData.status = JSON.stringify({
            auditStatusId: taskFormData.auditStatusId,
          });
          break;
        case "CRO":
          taskFormData.status = JSON.stringify({
            caseOutcomeIds: taskFormData.caseOutcomeIds,
          });
          break;
        case "RS":
          taskFormData.status = null;
          break;
        case "LDD":
          taskFormData.status = null;
          break;
        case "PRCRO":
          taskFormData.status = JSON.stringify({
            caseOutcomeIds: taskFormData.caseOutcomeIds,
          });
          break;
        default:
          taskFormData.status = null;
      }
      taskFormData.triggerType = taskFormData.triggerId;
      taskFormData.categoryType = taskCategoryTypeList?.filter(
        (x) => x.value == templateSelected[0]?.taskCategoryTypeValue
      );
      if (
        roundTaskTypeMode == TOGGLE_ROUND_TASK_TYPE.PROCESS_TEMPLATE_ROUND_TASK
      ) {
        const dataToSave = formatProcessRoundTaskObjectToSave(
          taskFormData,
          selectedRoundData,
          templateSelected
        );
        dataToSave.uniqueProcessTemplateTaskTriggerId = new Guid().toString();
        if (
          taskFormData.triggerId &&
          taskFormData.triggerId.toUpperCase() === "PTSC"
        ) {
          dataToSave.uniqueDependentTaskTriggerId =
            taskFormData.previousRefTaskId;
        }
        if (addTaskModeValue == ADD_TASK_MODE.EDIT) {
          dataToSave.uniqueProcessTemplateTaskTriggerId =
            taskFormData.uniqueProcessTemplateTaskTriggerId;
          dispatch({
            type: UPDATE_PROCESS_TEPLATE_ROUND_TASK,
            data: {
              taskData: dataToSave,
              processRoundData: processRoundData,
              newUniqueTriggerId: new Guid().toString(),
            },
          });
        } else {
          dataToSave.uniqueProcessTemplateTaskTriggerId = new Guid().toString();
          dispatch({
            type: ADD_PROCESS_TEPLATE_ROUND_TASK,
            data: { taskData: dataToSave },
          });
        }
      } else if (roundTaskTypeMode == TOGGLE_ROUND_TASK_TYPE.EA_ROUND_TASK) {
        const dataToSave = formatEaRoundTaskObjectToSave(
          taskFormData,
          eaRound,
          templateSelected
        );
        dispatch({
          type: ADD_EA_ROUND_TASK,
          data: { taskData: dataToSave },
        });
      }
      var accordionSequenceNo = selectedRoundData.sequenceNo
        ? selectedRoundData.sequenceNo
        : accordionNo;
      const accordionInstance = dxAccordion.getInstance(
        $("[taskListAccordionSequenceNo=" + accordionSequenceNo + "]") as any
      );
      accordionInstance?.option("selectedIndex", 0);
      props.toggleAddNewTaskPopupVisible(false);
    }
  };
  return (
    <MdaePopup
      deferRendering={false}
      onHiding={() => {
        setIsAddButtonClicked(false);
      }}
      width={510}
      height={
        roundTaskTypeMode == TOGGLE_ROUND_TASK_TYPE.EA_ROUND_TASK ? "auto" : 510
      }
      mdaeTitleRender={getNewTaskPopupTitle}
      mdaeDataUpdaterConfig={[
        {
          actionType: TOGGLE_ADD_TASK_POPUP,
          reducerName: "processTemplateReducer",
          widgetOptionBindings: {
            visible: "isAddNewTaskPopupVisible",
            MdaePopupTitle: "addTaskPopupTitle",
          },
        },
      ]}
      mdaeContentRender={() => {
        return (
          <div>
            <MdaePopupContent>{getPopupContent()}</MdaePopupContent>
          </div>
        );
      }}
      mdaeFooterRender={() => {
        return (
          <MdaePopupFooter>
            <MdaePopupFooterStartButtons>
              <MdaeButton
                id={"pnlAddTaskSecondaryBtn"}
                role={"secondary"}
                onClick={() => {
                  props.toggleAddNewTaskPopupVisible(false);
                }}
              >
                Cancel
              </MdaeButton>
            </MdaePopupFooterStartButtons>
            <MdaePopupFooterEndButtons>
              {!props.isViewOnlyMode && (
                <MdaeButton
                  id={"pnlAddTaskPrimaryBtn"}
                  role={"primary"}
                  validationGroup={taskTriggerValidationGroup}
                  onClick={(params) => {
                    setIsAddButtonClicked(true);
                    addTaskData(params);
                  }}
                >
                  {addTaskModeValue == ADD_TASK_MODE.ADD ? "Add" : "Update"}
                </MdaeButton>
              )}
            </MdaePopupFooterEndButtons>
          </MdaePopupFooter>
        );
      }}
    ></MdaePopup>
  );
};

export default AddTask;
